import Component from 'Component';
import axios from 'axios';

export default class API extends Component {

  configure() {

    axios.defaults.headers.get['Content-Type'] = 'application/json';
    axios.defaults.headers.post['Content-Type'] = 'application/json';
    axios.defaults.headers.delete['Content-Type'] = 'application/json';

    return super.configure();
  }

  initialize() {
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {
    this.App.Events.subscribe('api', this.query);
  }

  serialize(obj, prefix) {
    let str = [],
        p;
    for (p in obj) {
      if (obj.hasOwnProperty(p)) {
        let k = prefix ? prefix + "[" + p + "]" : p,
            v = obj[p];
        str.push((v !== null && typeof v === "object") ?
          this.serialize(v, k) :
          encodeURIComponent(k) + "=" + encodeURIComponent(v));
      }
    }
    return str.join("&");
  }

  query(method, url, data, callback) {

    if (typeof method === 'undefined') {
      this.logger('Method name is undefined');
      return;
    }

    this.logger(`${method.toUpperCase()} to [${url}] with data:`, data);

    let query = {
      method: method,
      url:    url,
      data:   data
    };

    if (method === 'get' && typeof data !== 'undefined') {
      query.url += '?' + this.serialize(data);
      query.data = null;
    }

    let result = axios(query);

    if (typeof callback === 'function') {
      return result.then((response) => {
        console.log(response);

        if (callback && typeof(callback) === 'function') {
          callback(response);
        }

        return true;

      }).catch((error) => {
        console.log(error);

        if (error.error) this.logger(error.error);

        // if (data.event) this.App.Events.publish(data.event, result);

        if (callback && typeof(callback) === 'function') {
          return callback(error.error);
        }

      });
    }

    return result;

  }

  get() {
    return this.query('get', ...arguments);
  }

  post() {
    return this.query('post', ...arguments);
  }

  put() {
    return this.query('put', ...arguments);
  }

  remove() {
    return this.query('delete', ...arguments);
  }

}